import './common'

$(document).ready(function() {
    console.log('// base.js');
});

$(document).ready(function() {
    // Scrolling to right position
    if ($('.has-error:visible:first').length) {
        var offset = -80;
        var target = $('.has-error:visible:first');
        if (target.length) {
            window.iFrameResizer = {
                readyCallback: function () {
                    setTimeout(function () {
                        window.parentIFrame.scrollToOffset(0, target.offset().top + offset);
                    }, 300);
                }
            };
        }
    } else {
        window.iFrameResizer = {
            readyCallback: function () {
                setTimeout(function () {
                    window.parentIFrame.scrollTo(0, 0);
                }, 300);
            }
        };
    }
});